module.exports = __webpack_public_path__ + "static/media/v11.e25d4c82.JPG";